import React from 'react';
import { useNavigate } from 'react-router-dom';

export interface TrainingMetadata {
  id: string;
  title: string;
  category: string;
  description: string;
  instructor: string;
  duration: string;
  date: string;
  tags: string[];
  materials: string[];
  status: 'active' | 'completed' | 'upcoming';
  path: string;
}

export const trainingMetadata: TrainingMetadata = {
  id: 'central-middle-debeth-ai-digital-leader-2026',
  title: '중부 AI에듀테크 담당자 연수',
  category: 'ai-edutech',
  description: '디벗 OS 아이패드 운영·MDM·수업 사례 공유 (중부 중등 핵심교원)',
  instructor: '담당 강사',
  duration: '3시간',
  date: '2026-04-22',
  tags: ['중부', '디벗', '아이패드', 'MDM', 'AI', '정보부장'],
  materials: ['CentralMiddleDebethAIDigitalLeaderTraining2026.tsx'],
  status: 'upcoming',
  path: '/teacher-training/digital/CentralMiddleDebethAIDigitalLeaderTraining2026',
};

/** 디벗 기기 운영·보관 안내 PPT (OneDrive 공유 — 새 탭) */
const DEBETH_DEVICE_OPERATION_PPT_URL =
  'https://1drv.ms/p/c/f326a53b9af299ff/IQQUO7bGlGjZS4sRLMmvGQUZAW0TCm8o5P2FY4Ms6sUHpnA';

/** PowerPoint 웹 뷰어 iframe용(OneDrive에서 제공하는 임베드 주소) */
const DEBETH_DEVICE_OPERATION_PPT_EMBED_SRC = `${DEBETH_DEVICE_OPERATION_PPT_URL}?wdAr=1.7770833333333333&wdEaaCheck=1`;

/** ASM·MDM 운영 안내 PPT (OneDrive 공유 — 새 탭) */
const ASM_MDM_OPERATION_PPT_URL =
  'https://1drv.ms/p/c/f326a53b9af299ff/IQRYl0qPpldkRKwq_Uiux96LAdmBnOmCcMjxfgGcPe0UplY';

/** ASM·MDM PPT 임베드(OneDrive 제공 파라미터: em=2) */
const ASM_MDM_OPERATION_PPT_EMBED_SRC = `${ASM_MDM_OPERATION_PPT_URL}?em=2&wdAr=1.7770833333333333&wdEaaCheck=1`;

/** MDM 안내 PPT (OneDrive 공유 — 새 탭) */
const MDM_OPERATION_PPT_URL =
  'https://1drv.ms/p/c/f326a53b9af299ff/IQQ-AO--ArKoSJhP2yuMvW-cAWkhRkHTDCJ1KAllgaRGxBc';

/** MDM PPT 임베드(OneDrive 제공 파라미터: em=2) */
const MDM_OPERATION_PPT_EMBED_SRC = `${MDM_OPERATION_PPT_URL}?em=2&wdAr=1.7770833333333333&wdEaaCheck=1`;

/** 수업 활용 사례·Tip 안내 PPT (OneDrive 공유 — 새 탭) */
const LESSON_CASES_PPT_URL =
  'https://1drv.ms/p/c/f326a53b9af299ff/IQRQ0a163recQr0pUAGPg1-rAbB0kJM9OD9vlpocz0NarBg';

/** 수업 활용 사례 PPT 임베드(OneDrive 제공 파라미터: em=2) */
const LESSON_CASES_PPT_EMBED_SRC = `${LESSON_CASES_PPT_URL}?em=2&wdAr=1.7770833333333333&wdEaaCheck=1`;

/** 연수 전 사전 설문 (survey.co.kr) */
const PRE_TRAINING_SURVEY_URL =
  'https://www.survey.co.kr/?ACCESS_KEY=f0ea4615740c4784ad32&grpid=&UID=';

/** 연수 후 설문 (survey.co.kr) */
const POST_TRAINING_SURVEY_URL =
  'https://www.survey.co.kr/?ACCESS_KEY=cb785ef52f5844b0ae52&grpid=&UID=';

/** 연수 만족도 조사 (Google Forms) */
const SATISFACTION_SURVEY_URL = 'https://forms.gle/jH9EPd7iayuyizcYA';

/** 연수 Padlet 보드 */
const TRAINING_PADLET_URL = 'https://padlet.com/phraha7_3/3-4-22-2026-ai-64ephyheezwed8ti';

const CentralMiddleDebethAIDigitalLeaderTraining2026: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        width: '100%',
        minHeight: '100%',
        boxSizing: 'border-box',
        padding: '24px',
        margin: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '24px', flexWrap: 'wrap', gap: '12px' }}>
        <button
          type="button"
          onClick={() => navigate('/teacher-training/training-pages')}
          style={{
            marginRight: '8px',
            padding: '8px 16px',
            backgroundColor: '#1976d2',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          ← 돌아가기
        </button>
        <h1 style={{ fontSize: '2rem', fontWeight: 'bold', margin: 0 }}>
          2026 중부 중등 디벗 핵심교원 AI·디지털 리더 연수
        </h1>
      </div>

      <div
        id="패들렛"
        style={{
          marginBottom: '24px',
          border: '2px solid #26a69a',
          borderRadius: '8px',
          padding: '16px 20px',
          backgroundColor: '#e0f2f1',
          boxShadow: '0 2px 6px rgba(38,166,154,0.15)',
        }}
      >
        <h2 style={{ fontWeight: 'bold', margin: '0 0 10px 0', fontSize: '1.25rem', color: '#00695c' }}>
          🧩 연수 Padlet 보드
        </h2>
        <p style={{ color: '#37474f', margin: '0 0 12px 0', fontSize: '1rem', lineHeight: 1.6 }}>
          연수 자료 공유와 참여자 기록은 아래 Padlet 보드에서 확인해 주세요.
        </p>
        <a
          href={TRAINING_PADLET_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'inline-block',
            padding: '10px 18px',
            backgroundColor: '#00897b',
            color: 'white',
            borderRadius: '6px',
            textDecoration: 'none',
            fontWeight: 600,
            fontSize: '1rem',
          }}
        >
          Padlet 열기 →
        </a>
      </div>

      <div
        id="사전-설문"
        style={{
          marginBottom: '24px',
          border: '2px solid #1976d2',
          borderRadius: '8px',
          padding: '16px 20px',
          backgroundColor: '#e3f2fd',
          boxShadow: '0 2px 6px rgba(25,118,210,0.15)',
        }}
      >
        <h2 style={{ fontWeight: 'bold', margin: '0 0 10px 0', fontSize: '1.25rem', color: '#0d47a1' }}>
          📋 연수 전 사전 설문
        </h2>
        <p style={{ color: '#37474f', margin: '0 0 12px 0', fontSize: '1rem', lineHeight: 1.6 }}>
          연수에 참여하시기 전에 아래 링크에서 사전 설문에 응답해 주시면 준비에 큰 도움이 됩니다.
        </p>
        <a
          href={PRE_TRAINING_SURVEY_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'inline-block',
            padding: '10px 18px',
            backgroundColor: '#1976d2',
            color: 'white',
            borderRadius: '6px',
            textDecoration: 'none',
            fontWeight: 600,
            fontSize: '1rem',
          }}
        >
          사전 설문 열기 →
        </a>
      </div>

      <div
        style={{
          marginBottom: '24px',
          border: '1px solid #ccc',
          padding: '16px',
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          backgroundColor: 'white',
        }}
      >
        <h2 style={{ fontWeight: 'bold', marginBottom: '16px', fontSize: '1.25rem' }}>📚 목차</h2>
        <ul style={{ listStyleType: 'none', padding: 0 }}>
          {[
            ['#패들렛', '연수 Padlet 보드'],
            ['#사전-설문', '연수 전 사전 설문'],
            ['#연수-개요', '연수 개요'],
            ['#아이패드-운영', '아이패드 운영·보관 안내'],
            ['#asm-mdm-운영', '🍎 ASM·MDM 기반 디벗 기기 운영'],
            ['#mdm-기기관리', '🔧 MDM 기기관리·앱 배포'],
            ['#수업-사례', '수업 활용 사례·운영 Tip'],
            ['#연수-과제', '연수 과제'],
            ['#참고-자료', '참고 자료'],
            ['#만족도-조사', '연수 후 설문·만족도 조사'],
          ].map(([hash, label]) => (
            <li key={hash} style={{ marginBottom: '8px' }}>
              <a href={hash} style={{ textDecoration: 'none', color: '#1976d2', fontWeight: 500 }}>
                {label}
              </a>
            </li>
          ))}
        </ul>
      </div>

      <div style={{ display: 'flex', alignItems: 'end', marginBottom: '24px', gap: '16px' }}>
        <p style={{ color: '#666', margin: 0, fontSize: '1rem', lineHeight: '1.6' }}>
          중부 관내 중등 디벗 핵심교원(정보부장)을 위한 연수 페이지입니다.
          <br />
          아이패드 운영, MDM으로 앱을 배포·관리하는 흐름, 그리고 현장 사례를 함께 나눕니다.
        </p>
      </div>

      <h2 style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '1.5rem' }} id="연수-개요">
        연수 개요
      </h2>
      <div
        style={{
          backgroundColor: '#f8f9fa',
          border: '2px solid #667eea',
          borderRadius: '8px',
          padding: '16px',
          marginBottom: '16px',
        }}
      >
        <p
          style={{
            color: '#333',
            margin: '0 0 12px 0',
            fontSize: '1.125rem',
            fontWeight: '600',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            flexWrap: 'wrap',
          }}
        >
          📅 연수 일정: 2026년 4월 22일 (수) 15:00 ~ 18:00 (3시간)
        </p>
        <p style={{ color: '#444', margin: '0 0 8px 0', fontSize: '1rem', lineHeight: 1.65 }}>
          📍 장소: 상연재 서울시청점 본관 (중구 세종대로 19길 16, 성공회빌딩 2층)
        </p>
        <p style={{ color: '#444', margin: 0, fontSize: '1rem', lineHeight: 1.65 }}>
          👥 대상: 중부 관내 중등 디벗 핵심교원(디벗 OS 아이패드 사용교 정보부장) 29명
        </p>
      </div>
      <p style={{ color: '#666', marginBottom: '8px', fontSize: '1rem', lineHeight: '1.6' }}>
        본 연수는 다음과 같은 순서로 진행합니다.
      </p>
      <ul style={{ color: '#666', marginBottom: '24px', fontSize: '1rem', lineHeight: '1.6' }}>
        <li>
          <b>아이패드 운영 관리</b>: 충전·보관·일상 점검 등 교내 운영 시 유의할 점
        </li>
        <li>
          <b>ASM·MDM 운영</b>: ASM·MDM을 바탕으로 한 계정·기기·앱·학적 운영 흐름 이해
        </li>
        <li>
          <b>MDM</b>: 기기 등록·앱 배포·앱 삭제 흐름을 화면으로 따라가며 익히기
        </li>
        <li>
          <b>사례·Q&amp;A</b>: 수업·학년·교과에 맞는 활용 아이디어와 운영 Tip, 질의응답
        </li>
      </ul>

      <h2 style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '1.5rem' }} id="아이패드-운영">
        📱 아이패드 운영·보관 안내
      </h2>
      <p style={{ color: '#666', marginBottom: '12px', fontSize: '1rem', lineHeight: '1.6' }}>
        디벗 OS 아이패드는 수업과 행정에서 매일 쓰이므로, 충전·보관·점검 습관을 함께 정리합니다.
      </p>
      <div
        style={{
          maxWidth: '952px',
          width: '100%',
          marginLeft: 'auto',
          marginRight: 'auto',
          marginBottom: '24px',
          textAlign: 'center',
        }}
      >
        <p style={{ color: '#666', marginBottom: '12px', fontSize: '1rem', lineHeight: '1.65' }}>
          <b>발표 자료(PPT)</b>:{' '}
          <a
            href={DEBETH_DEVICE_OPERATION_PPT_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#1976d2' }}
          >
            디벗 기기 운영 ppt (OneDrive에서 열기)
          </a>
          <span style={{ color: '#888' }}> — 운영·보관 안내 슬라이드</span>
        </p>
        <p style={{ fontSize: '0.8125rem', color: '#888', margin: '0 0 8px 0', lineHeight: 1.5 }}>
          페이지 안 미리보기(OneDrive 공식 임베드). 안 보이면 위 링크로 새 탭에서 여세요.
        </p>
        <div
          style={{
            borderRadius: '8px',
            overflow: 'hidden',
            border: '1px solid #e0e0e0',
            width: '100%',
            aspectRatio: '952 / 576',
            position: 'relative',
            backgroundColor: '#fafafa',
          }}
        >
          <iframe
            title="PowerPoint Viewer"
            src={DEBETH_DEVICE_OPERATION_PPT_EMBED_SRC}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              border: 'none',
              display: 'block',
            }}
            loading="lazy"
            allowFullScreen
          />
        </div>
      </div>
      <ul style={{ color: '#666', marginBottom: '24px', fontSize: '1rem', lineHeight: '1.65' }}>
        <li>
          <b>충전</b>: 수업 전 일괄 충전 거치, 전원 케이블 정리·라벨링으로 분실을 줄입니다.
        </li>
        <li>
          <b>보관</b>: 학년·반·세트별 보관함, 대여·반납 기록(간단한 체크리스트)을 두면 운영이 수월합니다.
        </li>
        <li>
          <b>점검</b>: 화면·케이스 파손, 애플 펜실 분실 등 이상 시 담당자·행정실 연계 절차를 안내합니다.
        </li>
        <li>
          <b>보안</b>: 분실·도난 시 즉시 MDM에서 기기 상태를 확인하고, 필요 시 원격 잠금 등 지침을 따릅니다.
        </li>
      </ul>

      <h2 style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '1.5rem' }} id="asm-mdm-운영">
        🍎 ASM·MDM 기반 디벗 기기 운영
      </h2>
      <p style={{ color: '#666', marginBottom: '12px', fontSize: '1rem', lineHeight: '1.6' }}>
        학교의 Apple School Manager(ASM)와 MDM 환경을 바탕으로 계정 생성, 기기 배포, 앱 관리, 학적 변동 처리까지 디벗 운영의 전체 흐름을 이해합니다.
      </p>
      <div
        style={{
          maxWidth: '952px',
          width: '100%',
          marginLeft: 'auto',
          marginRight: 'auto',
          marginBottom: '20px',
          textAlign: 'center',
        }}
      >
        <p style={{ color: '#666', marginBottom: '12px', fontSize: '1rem', lineHeight: '1.65' }}>
          <b>ASM·MDM 안내(PPT)</b>:{' '}
          <a
            href={ASM_MDM_OPERATION_PPT_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#1976d2' }}
          >
            OneDrive에서 열기
          </a>
        </p>
        <p style={{ fontSize: '0.8125rem', color: '#888', margin: '0 0 8px 0', lineHeight: 1.5 }}>
          페이지 안 미리보기(OneDrive 공식 임베드). 안 보이면 위 링크로 새 탭에서 여세요.
        </p>
        <div
          style={{
            borderRadius: '8px',
            overflow: 'hidden',
            border: '1px solid #e0e0e0',
            width: '100%',
            aspectRatio: '952 / 576',
            position: 'relative',
            backgroundColor: '#fafafa',
          }}
        >
          <iframe
            title="PowerPoint Viewer"
            src={ASM_MDM_OPERATION_PPT_EMBED_SRC}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              border: 'none',
              display: 'block',
            }}
            loading="lazy"
            allowFullScreen
          />
        </div>
      </div>
      <ul style={{ color: '#666', marginBottom: '24px', fontSize: '1rem', lineHeight: '1.65' }}>
        <li>
          <b>계정·배포 관리</b>: 학생·교직원 계정 생성 방식과 SFTP 기반 일괄 등록, ASM–MDM 연동 구조를 익힙니다.
        </li>
        <li>
          <b>앱·기기 운영</b>: 앱 구매·배포 원칙과 기기 초기 배부, 삭제·회수, 수업용 제한 정책 적용 흐름을 확인합니다.
        </li>
        <li>
          <b>학적·보안·동의</b>: 전입·전출·진급·졸업에 따른 계정 처리 절차와 구글/MS 연합 인증, 개인정보 동의 유의사항을 함께 살펴봅니다.
        </li>
      </ul>

      <h2 style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '1.5rem' }} id="mdm-기기관리">
        🔧 MDM 기기관리·앱 배포
      </h2>
      <p style={{ color: '#666', marginBottom: '12px', fontSize: '1rem', lineHeight: '1.6' }}>
        학교가 사용하는 MDM(모바일 기기 관리) 콘솔에서 앱을 배포·업데이트·삭제하는 기본 흐름을 화면으로 따라가며 익힙니다.
      </p>
      <div
        style={{
          maxWidth: '952px',
          width: '100%',
          marginLeft: 'auto',
          marginRight: 'auto',
          marginBottom: '20px',
          textAlign: 'center',
        }}
      >
        <p style={{ color: '#666', marginBottom: '12px', fontSize: '1rem', lineHeight: '1.65' }}>
          <b>MDM 안내(PPT)</b>:{' '}
          <a
            href={MDM_OPERATION_PPT_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#1976d2' }}
          >
            OneDrive에서 열기
          </a>
        </p>
        <p style={{ fontSize: '0.8125rem', color: '#888', margin: '0 0 8px 0', lineHeight: 1.5 }}>
          페이지 안 미리보기(OneDrive 공식 임베드). 안 보이면 위 링크로 새 탭에서 여세요.
        </p>
        <div
          style={{
            borderRadius: '8px',
            overflow: 'hidden',
            border: '1px solid #e0e0e0',
            width: '100%',
            aspectRatio: '952 / 576',
            position: 'relative',
            backgroundColor: '#fafafa',
          }}
        >
          <iframe
            title="PowerPoint Viewer"
            src={MDM_OPERATION_PPT_EMBED_SRC}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              border: 'none',
              display: 'block',
            }}
            loading="lazy"
            allowFullScreen
          />
        </div>
      </div>
      <ul style={{ color: '#666', marginBottom: '24px', fontSize: '1rem', lineHeight: '1.65' }}>
        <li>
          <b>앱 배포</b>: 교육용 앱을 그룹(학년·담임·과목)별로 묶어 배포하는 방식을 확인합니다.
        </li>
        <li>
          <b>앱 삭제</b>: 불필요한 앱 제거, 라이선스·용량 관점에서 정리하는 절차를 익힙니다.
        </li>
        <li>
          <b>프로파일·제한</b>: 수업 시간대에 필요한 제한 정책이 있다면, 담당자 가이드에 따라 조정합니다.
        </li>
      </ul>

      <h2 style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '1.5rem' }} id="수업-사례">
        💡 수업 활용 사례·운영 Tip
      </h2>
      <p style={{ color: '#666', marginBottom: '12px', fontSize: '1rem', lineHeight: '1.6' }}>
        현장에서 바로 쓸 수 있는 활용 아이디어 예시입니다. 연수 중에 학교 사례를 더해 나가면 좋습니다.
      </p>
      <div
        style={{
          maxWidth: '952px',
          width: '100%',
          marginLeft: 'auto',
          marginRight: 'auto',
          marginBottom: '20px',
          textAlign: 'center',
        }}
      >
        <p style={{ color: '#666', marginBottom: '12px', fontSize: '1rem', lineHeight: '1.65' }}>
          <b>수업 활용 사례(PPT)</b>:{' '}
          <a
            href={LESSON_CASES_PPT_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#1976d2' }}
          >
            OneDrive에서 열기
          </a>
        </p>
        <p style={{ fontSize: '0.8125rem', color: '#888', margin: '0 0 8px 0', lineHeight: 1.5 }}>
          페이지 안 미리보기(OneDrive 공식 임베드). 안 보이면 위 링크로 새 탭에서 여세요.
        </p>
        <div
          style={{
            borderRadius: '8px',
            overflow: 'hidden',
            border: '1px solid #e0e0e0',
            width: '100%',
            aspectRatio: '952 / 576',
            position: 'relative',
            backgroundColor: '#fafafa',
          }}
        >
          <iframe
            title="PowerPoint Viewer"
            src={LESSON_CASES_PPT_EMBED_SRC}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              border: 'none',
              display: 'block',
            }}
            loading="lazy"
            allowFullScreen
          />
        </div>
      </div>
      <ul style={{ color: '#666', marginBottom: '24px', fontSize: '1rem', lineHeight: '1.65' }}>
        <li>
          <b>사례 1</b>: 1:1 기기로 과제 제출·채점 피드백을 디지털로 모으고, MDM으로 필요한 앱만 배포해 수업 집중도를 높인 사례
        </li>
        <li>
          <b>사례 2</b>: 팀 활동 시 공유 노트·화이트보드 앱을 활용하고, 연수 후 미사용 앱은 정리해 용량·관리 부담을 줄인 사례
        </li>
        <li>
          <b>Tip</b>: 정보부장-담임-교과협의 간 역할 분담(문의 창구, 기기 수리, 앱 요청 주기)을 학교마다 한 장으로 정리해 두면 유지보수가 쉽습니다.
        </li>
      </ul>

      <h2 style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '1.5rem' }} id="연수-과제">
        연수 과제
      </h2>
      <p style={{ color: '#666', marginBottom: '16px', fontSize: '1rem', lineHeight: '1.6' }}>
        아래 질문 예시를 참고해 <b>Padlet의 각 학교 칸</b>에 학교별로 1건씩 남겨 주세요.
      </p>
      <ul style={{ color: '#666', marginBottom: '24px', fontSize: '1rem', lineHeight: '1.65' }}>
        <li>
          우리 학교 정보업무 운영에서 가장 불편한 점 1가지
        </li>
        <li>
          자체적으로 개선이 필요하다고 느끼는 부분 1가지
        </li>
        <li>
          다른 학교와 공유하고 싶은 운영 팁 또는 사례 1가지
        </li>
      </ul>
      <p style={{ color: '#666', marginBottom: '24px', fontSize: '0.95rem', lineHeight: '1.6' }}>
        작성하러 가기:{' '}
        <a href={TRAINING_PADLET_URL} target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2' }}>
          연수 Padlet 보드
        </a>
      </p>

      <h2 style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '1.5rem' }} id="참고-자료">
        참고 자료
      </h2>
      <p style={{ color: '#666', marginBottom: '12px', fontSize: '1rem', lineHeight: '1.6' }}>
        학교에서 배포한 안내 자료와 외부 가이드를 함께 참고하세요.
      </p>
      <ul style={{ color: '#666', marginBottom: '24px', fontSize: '1rem', lineHeight: '1.65' }}>
        <li>
          <b>마루 정보부장(info-chief)</b>:{' '}
          <a
            href="https://maruedu.kr/info-chief"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#1976d2' }}
          >
            maruedu.kr/info-chief
          </a>
          <span style={{ color: '#888' }}> — 학교 정보부장용 도구·자료 모음</span>
        </li>
        <li>
          <b>프로젝트 내 PDF</b>
          <ul>
            <li>
              <a
                href="/pdfs/info-chief/디벗 기기 매뉴얼_아이패드.pdf"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#1976d2' }}
              >
                디벗 기기 매뉴얼(아이패드)
              </a>
            </li>
            <li>
              <a
                href="/pdfs/info-chief/단말기 보안.pdf"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#1976d2' }}
              >
                단말기 보안
              </a>
            </li>
            <li>
              <a
                href="/pdfs/info-chief/공교육 에듀테크 개인정보보호 가이드(2026.2.).pdf"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#1976d2' }}
              >
                공교육 에듀테크 개인정보보호 가이드(2026.2.)
              </a>
            </li>
          </ul>
        </li>
        <li>
          <b>Apple 교육</b>:{' '}
          <a href="https://www.apple.com/kr/education/" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2' }}>
            Apple 교육 개요
          </a>
        </li>
      </ul>

      <h2 style={{ fontWeight: 'bold', marginBottom: '16px', fontSize: '1.5rem' }} id="만족도-조사">
        연수 후 설문·만족도 조사
      </h2>
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          padding: '32px',
          marginBottom: '24px',
          textAlign: 'center',
        }}
      >
        <p
          style={{
            color: '#666',
            marginBottom: '20px',
            fontSize: '1.125rem',
            lineHeight: '1.6',
            fontWeight: '500',
          }}
        >
          금일 연수 이수하시느라 고생 많으셨습니다. 🙏
          <br />
          아래 두 가지 설문에 각각 참여해 주시면 감사하겠습니다.
        </p>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '12px',
            justifyContent: 'center',
            alignItems: 'stretch',
          }}
        >
          <a
            href={POST_TRAINING_SURVEY_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              padding: '14px 22px',
              backgroundColor: '#1976d2',
              color: 'white',
              borderRadius: '8px',
              fontWeight: 600,
              fontSize: '1rem',
              textDecoration: 'none',
              minWidth: '200px',
            }}
          >
            📋 연수 후 설문 (survey.co.kr)
          </a>
          <a
            href={SATISFACTION_SURVEY_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              padding: '14px 22px',
              backgroundColor: '#0f9d58',
              color: 'white',
              borderRadius: '8px',
              fontWeight: 600,
              fontSize: '1rem',
              textDecoration: 'none',
              minWidth: '200px',
            }}
          >
            📝 만족도 조사 (Google Forms)
          </a>
        </div>
        <p style={{ color: '#888', marginTop: '16px', marginBottom: 0, fontSize: '0.875rem', lineHeight: 1.55 }}>
          만족도 조사: (중부) 2026 중등 디벗 핵심교원 AI·디지털 리더 직무연수 만족도 조사
        </p>
      </div>
      <p style={{ color: '#666', marginBottom: '16px', fontSize: '1rem', lineHeight: '1.6' }}>
        <b>연수 문의</b>
        <br />
        추가 문의는 교육청·연수 담당자 안내에 따라 연락해 주세요.
      </p>
    </div>
  );
};

export default CentralMiddleDebethAIDigitalLeaderTraining2026;
